module.exports = __webpack_public_path__ + "img/room-types-buttons-add.91804fa0.svg";